
import vSelect from './vselect'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async doQuery () {
console.log('开始时间')
console.log(this.begin_year)
console.log('结束时间')
console.log(this.end_year)
if (this.begin_year === 0 || this.begin_year === '') {
this.$vux.alert.show({
title: '提示', content: '请选择起始年份！' })
return
}
if (this.end_year !== 0 && this.end_year !== '' && this.end_year < this.begin_year) {
this.$vux.alert.show({
title: '提示', content: '结束年份应大于等于起始年份！' })
return
}
if (this.iflag !== true && this.eflag !== true && this.ieflag !== true) {
if (this.$route.query.code !== '6' && this.$route.query.code !== '7' && this.$route.query.code !== '13' && this.$route.query.code !== '14') {
this.$vux.alert.show({
title: '提示', content: '请选择一种进出口方式！' })
return
}
}
if (this.$route.query.code === '15') {
if (this.keyword === '') {
this.$vux.alert.show({
title: '提示', content: '请输入商品编码或者关键字！' })
return
}
}
if (this.$route.query.code === '16' || this.$route.query.code === '17') {
if (this.keyword === '') {
this.$vux.alert.show({
title: '提示', content: '请输入商品编码及关键字！' })
return
}
if (this.country === '') {
this.$vux.alert.show({
title: '提示', content: '请输入国家（地区）代码及关键字！' })
return
}
}
if (this.$route.query.code === '18') {
if (this.keyword === '') {
this.$vux.alert.show({
title: '提示', content: '请输入商品编码及关键字！' })
return
}
}





if ((this.chy === true && this.usd === true) || (this.chy === false && this.usd === false)) {
this.$vux.alert.show({
title: '提示', content: '请选择一种币制！' })
return
}
if (this.$route.query.code === '12') {
if ((this.iflag === true && this.eflag === true) || (this.iflag === false && this.eflag === false)) {
this.$vux.alert.show({
title: '提示', content: '请选择一种进出口方式！' })
return
}
}
if (this.begin_year === '') {
this.begin_year = 0
}
if (this.end_year === '') {
this.end_year = 0
}
this.$router.push({name: 'TradeStateByDataDetails', params: {enumtype: this.$route.query.code, begin_year: this.begin_year, end_year: this.end_year, country: this.country, dis_country: this.dis_country, goods: this.goods, keyword: this.keyword, trademode: this.trademode, checkdis: this.checkdis, begin_index: this.begin_index, end_index: this.end_index, ieflag: this.ieflag, iflag: this.iflag, eflag: this.eflag, usd: this.usd, chy: this.chy, inoutover: this.inoutover, yearchack: this.yearchack, shipmode: this.shipmode, chacks: this.chacks, chapter: this.chapter, unit: this.unit, importcountry: this.importcountry, exportcountry: this.exportcountry, inareadis: this.inareadis, customs: this.customs, companynature: this.companynature}})
},
async getYears () {
const queryPromise = await this.$http.get('/API/TradeStat/GetTradeYear?enumtype=' + this.$route.query.code)
return queryPromise.data
},
async getTradeMode () {
const queryPromise = await this.$http.get('/API/TradeStat/GetTradeMode?enumtype=' + this.$route.query.code)
return queryPromise.data
},
async getShipperMode () {
const queryPromise = await this.$http.get('/API/TradeStat/GetShipperMode?enumtype=' + this.$route.query.code)
return queryPromise.data
},
clear () {
this.keyword = ''
this.begin_index = ''
this.orgincoutry = ''
this.end_index = ''
this.dis_country = ''
this.shipmode = ''
this.customs = ''
this.inareadis = ''
this.checkdis = ''
this.companynature = ''
this.trademode = ''
this.goods = ''
this.begin_year = 0
this.end_year = 0
this.chapter = ''
this.chacks = false
this.country = ''
this.yearchack = false
this.inoutover = false
this.chy = false
this.usd = false
this.eflag = false
this.iflag = false
this.ieflag = false
},
async getTableName () {
let no = this.$route.query.code
this.tableindex = no
const queryPromise = await this.$http.get('/API/TradeStat/GroupTradeByNo'
, {params: {no: no, type: 1}})
this.tablename = queryPromise.data.G_NAME
if (no === '9') {
this.tablename = '进出口商品目的地/货源地总值表'
}
}
},
data () {
return {
tableindex: 1,
tablename: '',
begin_year: 0,
end_year: 0,
year: 0,
keyword: '',
begin_index: '',
orgincoutry: '',
end_index: '',
dis_country: '',
shipmode: '',
customs: '',
inareadis: '',
checkdis: '',
companynature: '',
trademode: '',
goods: '',
unit: '',
chapter: '',
importcountry: '',
exportcountry: '',
chacks: false,
country: '',
yearchack: false,
inoutover: false,
chy: false,
usd: false,
eflag: false,
iflag: false,
ieflag: false,
g_name: '',
source: '',
source_num: '',
yearList: [
{years: '1981', ID: ''},
{years: '1982', ID: ''},
{years: '2017', ID: ''}
],
trademodeList: [
{trademodes: '', ID: ''},
{trademodes: '一般贸易', ID: ''},
{trademodes: '进料对口', ID: ''},
{trademodes: '来料加工', ID: ''}
],
companynatureList: [
{companynatures: '', ID: ''},
{companynatures: '国有企业', ID: ''},
{companynatures: '外商独资', ID: ''},
{companynatures: '中外合资', ID: ''},
{companynatures: '中外合作', ID: ''},
{companynatures: '集体企业', ID: ''},
{companynatures: '私营企业', ID: ''},
{companynatures: '其他企业性质', ID: ''}
],
shipperList: [
{shippers: '', ID: ''},
{shippers: '水路运输', ID: ''},
{shippers: '陆路运输', ID: ''}
]
}
},
async activated () {
this.getTableName()
this.yearList = (await this.getYears()).sort().reverse()
if (this.yearList.length > 0) {
this.yearList.unshift('')
this.year = this.yearList[0]
}
this.trademodeList = (await this.getTradeMode()).sort().reverse()
if (this.trademodeList.length > 0) {
this.trademodeList.unshift('')
this.trademode = this.trademodeList[0]
}
this.shipperList = (await this.getShipperMode()).sort().reverse()
if (this.shipperList.length > 0) {
this.shipperList.unshift('')
this.shipmode = this.shipperList[0]
}
}
}



// WEBPACK FOOTER //
// ./src/components/TradeStateByDataQuery.vue